import { Cake, Instagram, Heart } from "lucide-react";

export const Footer = () => (
  <footer className="mt-24 border-t border-sugar-border bg-sugar-bg2">
    <div className="mx-auto grid max-w-7xl gap-8 px-6 py-14 md:grid-cols-3 lg:px-8">
      <div>
        <div className="flex flex-col leading-none">
          <span className="font-display text-4xl font-semibold lowercase tracking-tight text-sugar-ink">
            my sugar <span className="italic font-normal text-sugar-rose">obsession</span>
          </span>
          <span className="mt-2 text-[10px] font-bold uppercase tracking-[0.28em] text-sugar-ink2">Custom Cakes | by Sarah</span>
        </div>
        <p className="mt-4 max-w-xs text-sm leading-relaxed text-sugar-ink2">
          Handmade vintage & custom cakes, baked with love in Langley. Free delivery in Langley & Surrey, and on all orders over $200.
        </p>
      </div>
      <div>
        <h4 className="text-xs font-bold uppercase tracking-widest text-sugar-pink">Ordering</h4>
        <ul className="mt-4 space-y-2 text-sm text-sugar-ink2">
          <li>Same-day & next-day quick cakes</li>
          <li>Pre-order custom cakes by date</li>
          <li>Live order tracking</li>
          <li>Secure card checkout</li>
        </ul>
      </div>
      <div>
        <h4 className="text-xs font-bold uppercase tracking-widest text-sugar-pink">Say hi</h4>
        <a href="https://www.instagram.com" className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-sugar-ink hover:text-sugar-pink">
          <Instagram size={16} /> @mysugarobsession
        </a>
      </div>
    </div>
    <div className="border-t border-sugar-border py-5 text-center text-xs text-sugar-muted">
      Made with <Heart size={11} className="inline text-sugar-rose" fill="#C08A8A" /> in British Columbia &middot; &copy; {new Date().getFullYear()} My Sugar Obsession
    </div>
  </footer>
);
